
































import { Component, Vue } from "vue-property-decorator";
import * as TWEEN from "@tweenjs/tween.js";
const BarProps = Vue.extend({
  props: {
    barData: Object,
  },
});
@Component<Bar>({})
export default class Bar extends BarProps {
  private tween: any = null;
  public setHeart(val: number = 0) {
    
  }
  private infoIndex = 0;
  public setInfo(idx: number) {
    const infoText: any = this.$refs.infoText;
    clearInterval(this.infoIndex);
    if (idx == 0) {
      infoText.textContent = "";
      return;
    }
    
    if (idx == 1) {
      infoText.textContent = this.$i18n.t("message.noPet");
      this.infoIndex = setInterval(() => {
      infoText.textContent = "";
    }, 2000);
    }
    
  }
  public setProgress(val: number = 0, str: string) {
    const barText: any = this.$refs.barText;
    barText.textContent = str;
    
  }
  public setColor(){
    const barText: any = this.$refs.barText;
    barText.style.fill = "#ff3d4d";
  }
  public setColorBack(){
    const barText: any = this.$refs.barText;
    barText.style.fill = "#000000";
  }
  public data() {
    return {
      datas: this.barData,
    };
  }
}
